import { CardLoader } from 'components/organisms'
import ProductSizeView from 'domains/product-size/view/product-size-view'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import StringUtil from 'utils/string-util'
import InventoryView from 'domains/inventory/molecules/view'

const propTypes = {
  productDimension : PropTypes.object,
  flexDir          : PropTypes.oneOf([ 'row', 'column' ])
}

/**
 * Multi-purpose Product Dimension view.
 * It display about the Product Dimension information
 * @param {object} product
 */
const ProductDimensionView     = ({ productDimension, flexDir = 'row' }) => (
  <>

    <div className='p-3'>
      <h4>{ `Product Dimension - ${ productDimension.id }` }</h4>
      <p>
        { 'Merupakan item fisik yang unik berdasarkan ukuran.' }
      </p>
    </div>

    <div className={ `d-flex flex-${flexDir} flex-fill` } >
      {
        productDimension.size && (
          <ProductSizeView
            isLoading={ false }
            size={ productDimension.size_obj }
          />
        )
      }

      <Table bordered className='mb-0' size='sm'>
        <thead>
          <tr className='small text-uppercase font-weight-bolder'>
            <th colSpan={ 2 }>{ 'Measurements' }</th>
          </tr>
        </thead>
        <tbody>
          {
            productDimension.measurements && Object.keys(productDimension.measurements).map((measurementKeys, index) => (
              <tr key={ index }>
                <th scope='row'>{ StringUtil.humanize(measurementKeys) }</th>
                <td className='text-wrap'>{ productDimension.measurements[measurementKeys] }</td>
              </tr>
            ))
          }
        </tbody>
      </Table>

      {
        productDimension.inventory && (
          <InventoryView
            isLoading={ false }
            inventory={ productDimension.inventory }
          />
        )
      }
    </div>
  </>
)
ProductDimensionView.propTypes = propTypes

export default withLoader(ProductDimensionView, CardLoader)